import { WebStorageStateStore } from "oidc-client";

export const environment = {
  production: true,
  apiUrl: "http://horze.api.traggid.com",
  authSettings: {
        authority: 'http://localhost:5000/',
        client_id: 'horzeapp',
        redirect_uri: 'http://localhost:4200/auth-callback',
        post_logout_redirect_uri: 'http://localhost:4200/',
        response_type:"id_token token",
        scope:"openid profile traggidApi",
        filterProtocolClaims: true,
        loadUserInfo: true,
        userStore: new WebStorageStateStore({ store: window.localStorage })
  }
};



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/environments/environment.ts